import React, { Component } from "react";
import { connect } from "react-redux";
import {
  DetailValue,
  Icon,
  Loader,
  ModalActions,
  utils,
  FixedDropDownButton,
  subjektFormatter,
  formatDate,
  formatDateTime,
  localUTCToDateTime,
  authActions,
  HorizontalLoader,
} from "@mc/mc-legacy";
import { Alert, Button, Card, CardBody, CardHeader, Col, Container, DropdownItem, Row } from "reactstrap";
import KontaktyNotifikaceForm, { validateKontakty } from "../components/profile/KontaktyNotifikaceForm";
import * as ProfileActions from "../actions/ProfileActions";
import * as ChangePasswordResult from "../api/gen/core/ChangePasswordResult";
import * as TypDokladuInfo from "../api/TypDokladuInfo";
import * as TypAutentizace from "mc/lib/api/gen/ucty/v1/TypAutentizace";
import * as TypAutentizaceInfo from "../api/TypAutentizaceInfo";
import * as StavUctu from "mc/lib/api/gen/ucty/v1/StavUctu";
import AktivaceUctuForm from "../components/profile/AktivaceUctuForm";
import SpravaUctuApi from "../api/gen/core/SpravaUctuApi";
import * as TypVazbyInfo from "../api/TypVazbyInfo";
import UserProfileApi from "../api/gen/core/UserProfileApi";
import ChangePasswordForm from "../components/form/ChangePasswordForm";
import { toastr } from "react-redux-toastr";
import { SubmissionError } from "redux-form";
import * as TypSouhlasuInfo from "../api/TypSouhlasuInfo";
import SpravaKontaktuApi from "../api/gen/core/SpravaKontaktuApi";
import "./ProfilePage.scss";
import { i18n } from "../i18n/i18n";
import SubmitOnlyForm from "../components/form/SubmitOnlyForm";
import { withLang } from "../i18n/withLang";

enum TypExternichDat {
  CEKA = "CEKA",
  NACTENO = "NACTENO",
  NEDOSTUPNE = "NEDOSTUPNE",
}

const ZpusobyPrihlaseniPanel = ({ typExternichDat, userProfileLoginList, posledniUspesnaPrihlaseni, onPortalRedirect, lang }) => {
  return (
    <Card className="border-0 mb-4">
      <CardHeader className={"pb-0"}>
        <Row>
          <Col>
            <h2>{i18n(lang, "ProfilePage_loginTypes")}</h2>
          </Col>
        </Row>
      </CardHeader>
      <CardBody className="pt-2 pb-0">
        {userProfileLoginList.rows.map((autentizace, key) => {
          let logPrihlaseni = posledniUspesnaPrihlaseni.find(
            (l) => l.typAutentizace === autentizace.typAutentizace && l.login === autentizace.login
          );
          return (
            <AutentizaceInfo
              autentizace={autentizace}
              key={key}
              onPortalRedirect={onPortalRedirect}
              typExternichDat={typExternichDat}
              logPrihlaseni={logPrihlaseni}
            />
          );
        })}
      </CardBody>
    </Card>
  );
};

const DataBlock = ({
  children,
  label,
  className,
  ...other
}: React.PropsWithChildren<{ label: string; className?: string } & React.ComponentProps<typeof Col>>) => {
  return (
    <Col xs={12} sm={4} className={"pb-2" + (className ? " " + className : "")} {...other}>
      <DetailValue label={label}>{children}</DetailValue>
    </Col>
  );
};

class DocumentBlockComponent extends Component<any> {
  handleClick = () => {
    const { dispatch, userId, dokument } = this.props;
    dispatch(
      ModalActions.showAsyncWaiting(
        "",
        <div>
          <div className={"pb-2"}>{i18n(this.props.lang, "ProfilePage_documentDownloading")}</div>
          <HorizontalLoader />
        </div>,
        UserProfileApi.downloadDokument(userId, dokument.id),
        (url) => window.open((window as any).serverContextPath + url)
      )
    );
  };

  render() {
    const { dokument } = this.props;
    return (
      <a href="#" onClick={this.handleClick} className="pr-3">
        <Icon icon="file-pdf-o" className="pr-1" />
        {dokument.nazev}
      </a>
    );
  }
}

const DocumentBlock = withLang(connect()(DocumentBlockComponent));

/**
 * Odeslání zprávy o odstranění účtu.
 */
const sendAccountDeleteMessage = () => {
    const parentWindow = window.parent;

    if (parentWindow) {
        const sendObj = {
            type: "account-delete",
            result: "OK",
        };
        console.log(sendObj);

        parentWindow.postMessage(sendObj, "*");
    }
};

class ZakladniUdajeComponent extends React.Component<any> {
  showContactForm = () => {
    const { onChange, detail } = this.props;
    const formProps: any = {
      onSubmit: (submit) => {
        const errors = validateKontakty(submit.data);

        if (Object.keys(errors).length > 0) {
          throw new SubmissionError(errors);
        }

        return SpravaKontaktuApi.updateKontakty(this.props.detail.id, submit.data);
      },
      onSubmitSuccess: (data, dispatch) => {
        dispatch(ModalActions.hide());
        toastr.success(i18n(this.props.lang, "ProfilePage_baseKontaktyAktualizovany"));
        onChange && onChange();
      },
      overovatEmail: detail.data.overovatEmail,
      overovatTelefon: detail.data.overovatTelefon,
    };
    formProps.initialValues = {
      telefon: detail.data.telefon,
      telefonOveren: detail.data.telefonOveren,
      telefonNotifikace: detail.data.telefonNotifikace,
      email: detail.data.email,
      emailOveren: detail.data.emailOveren,
      emailNotifikace: detail.data.emailNotifikace,
      nezobrazovatNotifikace: detail.data.nezobrazovatNotifikace,
    };
    this.props.dispatch(
      ModalActions.show(KontaktyNotifikaceForm, formProps, i18n(this.props.lang, "ProfilePage_baseKontaktyTitle"), {
        size: "lg",
      })
    );
  };
  showSouhlasDetail = (souhlas) => {
    const souhlasDetail = () => (
      <div
        style={{
          padding: "1rem",
        }}
      >
        {souhlas.textSouhlas || ""}
      </div>
    );

    this.props.dispatch(
      ModalActions.show(souhlasDetail, {}, i18n(this.props.lang, `TypSouhlasu_${souhlas.typ}`), {
        size: "lg",
      })
    );
  };

    handleTrvaleOdstranit = (userId, existujeViceSubjektu?: boolean) => {
        this.props.dispatch(
            ModalActions.show(
                SubmitOnlyForm,
                {
                    handleSubmit: () => {
                        this.props.dispatch(ModalActions.hide());

                        this.props.dispatch(ModalActions.showAsyncWaiting(
                            "",
                            <div style={{minWidth: 320}}>
                                <div className={"pb-2"}>Mazání účtu</div>
                                <HorizontalLoader/></div>,
                            UserProfileApi.deleteUcet(userId),
                            () => {
                                console.log("succesfully removed user");
                                sendAccountDeleteMessage(); // pokud je v iframe, měl by portál vně eosp iframe zavřít, takže následující dialog by se neměl ani zobrazit

                                this.props.dispatch(
                                    ModalActions.showInfo(i18n(this.props.lang, "ProfilePage_ucetDeleteSuccessTitle"), i18n(this.props.lang, "ProfilePage_ucetDeleteSuccessMessage"), () => {
                                        this.props.dispatch(ModalActions.hide());
                                        window.location.reload();
                                    }, false, {noHeader: true})
                                );
                            },
                            (e) => {
                                toastr.error(i18n(this.props.lang, "ProfilePage_actionFailed"), e);
                            })
                        );
                    },
                    message: existujeViceSubjektu ? i18n(this.props.lang, "ProfilePage_ucetDeleteQuestion1") : i18n(this.props.lang, "ProfilePage_ucetDeleteQuestion2"),
                    submitText: i18n(this.props.lang, "ProfilePage_ucetDeleteAction"),
                },
                i18n(this.props.lang, "ProfilePage_ucetDeleteTitle"),
                {}
            )
        );
    };

  render() {
    const { externalDetail, detail, typExternichDat } = this.props;
    const { data } = detail;
    const nazevProfilu = data.nazev;
    const externiData = externalDetail.data || {};

    const actionTitle =
      typExternichDat === TypExternichDat.NEDOSTUPNE ? i18n(this.props.lang, "ProfilePage_actionInaccessible") : "";

    return (
      <Card className="border-0 mb-4">
        <CardHeader className={"pb-0"}>
          <Row noGutters>
            <Col xs={6} className="d-flex align-items-center">
              <h2 className={"mb-0"}>{i18n(this.props.lang, "ProfilePage_baseTitle")}</h2>
            </Col>
            <Col xs={6} className="text-right">
              <Button
                color="primary"
                outline
                onClick={this.showContactForm}
                disabled={typExternichDat !== TypExternichDat.NACTENO}
                title={actionTitle}
              >
                  {i18n(this.props.lang, "ProfilePage_baseYmenitKontakty")}
              </Button>
              {!data.popRezim && <FixedDropDownButton
                title={<Icon fixedWidth icon="ellipsis-v" />}
                className={"float-right ml-xs-1 ml-sm-3 px-2"}
                right
                color={"outline-primary"}
              >
                <DropdownItem
                  disabled={typExternichDat !== TypExternichDat.NACTENO}
                  title={actionTitle}
                  onClick={() => this.handleTrvaleOdstranit(data.userId)}
                >
                    {i18n(this.props.lang, "ProfilePage_ucetDeleteAction")}
                </DropdownItem>
              </FixedDropDownButton>}
            </Col>
          </Row>
        </CardHeader>
        <CardBody className="py-2">
          <Row key="nacionale">
            <DataBlock xs={12} sm={3} label={i18n(this.props.lang, "ProfilePage_baseJmenoPrijmeni")}>
              {nazevProfilu}
            </DataBlock>
            <DataBlock xs={12} sm={3} label={i18n(this.props.lang, "ProfilePage_baseDatumNarozeni")}>
              {formatDate(externiData.datumNarozeni)}
            </DataBlock>
            <DataBlock xs={12} sm={6} label={i18n(this.props.lang, "ProfilePage_baseAdresa")}>
              {externiData.adresa && subjektFormatter.getAdresa(externiData.adresa)}
            </DataBlock>
          </Row>
          <Row key="kontakt">
            <DataBlock
              xs={12}
              sm={3}
              label={externiData.typDokladu ? i18n(this.props.lang, `TypDokladu_${externiData.typDokladu}`) : i18n(this.props.lang, "ProfilePage_baseDoklad")}
            >
              {externiData.typDokladu && externiData.cisloDokladu}
            </DataBlock>
            <DataBlock xs={12} sm={3} label={i18n(this.props.lang, "ProfilePage_baseTelefon")}>
              {data.telefon}
            </DataBlock>
            <DataBlock label={i18n(this.props.lang, "ProfilePage_baseEmail")}>{data.email}</DataBlock>
          </Row>
          <Row key="souhlasy">
            <DataBlock label={i18n(this.props.lang, "ProfilePage_baseSouhlasy")} xs={12} sm={12}>
              {data.souhlasy.map((souhlas, i) => {
                return (
                  <Row key={`souhlas-${i}}`}>
                    <Col xs={12} sm={6}>
                      <Button color="link" onClick={() => this.showSouhlasDetail(souhlas)}>
                        {TypSouhlasuInfo.getCaption(souhlas.typ)}
                      </Button>
                    </Col>
                    <Col xs={12} sm={6}>
                      {formatDateTime(localUTCToDateTime(souhlas.datumUdeleni))}
                    </Col>
                  </Row>
                );
              })}
            </DataBlock>
          </Row>
        </CardBody>
      </Card>
    );
  }
}

const ZakladniUdajePanel = withLang(connect()(ZakladniUdajeComponent));

class AutentizaceInfoComponent extends React.Component<any> {
  handleChangePassword = (autentizace) => {
    const formProps = {
      onSubmit: (data) => {
        // Async validace - chceme až na tlačítko submit, proto je zde
        if (data.newPassword !== data.newPassword_repeat) {
          throw new SubmissionError({
            _error: i18n(this.props.lang, "Form_HeslaNeshoduji"),
          });
        }

        // we want to unite error visualitions -> we do not want ErrorApi
        return SpravaUctuApi.changePassword({ login: autentizace.login, oldPassword: data.oldPassword, newPassword: data.newPassword});
      },
      onSubmitSuccess: (data, dispatch) => {
        dispatch(ModalActions.hide());
        switch (data) {
            case ChangePasswordResult.REDIRECT_PORTAL:
                this.props.dispatch(
                    ModalActions.show(
                        SubmitOnlyForm,
                        {
                            handleSubmit: () => {
                                if (this.props?.onPortalRedirect) {
                                    this.props?.onPortalRedirect();
                                }
                                window.location.reload();
                            },
                            message: i18n(this, "ProfilePage_passwordChangeNoNewAttempts"),
                            submitText: "Ok",
                        },
                        i18n(this.props.lang, "ProfilePage_passwordChangeNoNewAttemptsTitle"),
                        {}
                    )
                );
                break;
            case ChangePasswordResult.OK:
                i18n(this.props.lang, "ProfilePage_passwordChanged");
                break;
        }
      },
    };
    const caption = i18n(this.props.lang, "ProfilePage_passwordChangeDialogTitle");
    this.props.dispatch(
      ModalActions.show(ChangePasswordForm, formProps, caption, {
        size: "lg",
      })
    );
  };
  renderAutentizaceAction = (typ, autentizace, typExternichDat) => {
    const actionTitle =
      typExternichDat === TypExternichDat.NEDOSTUPNE ? i18n(this.props.lang, "ProfilePage_actionInaccessible") : "";

    switch (typ) {
      case TypAutentizace.JMENO_HESLO:
        return (
          <Button
            color="primary"
            outline
            disabled={typExternichDat !== TypExternichDat.NACTENO}
            onClick={() => this.handleChangePassword(autentizace)}
            className="mb-2"
            title={actionTitle}
          >
            {i18n(this.props.lang, "ProfilePage_changePassword")}
          </Button>
        );

      case TypAutentizace.NIA:
      case TypAutentizace.MOJE_ID:
      case TypAutentizace.ISDS:
        return null;

      default:
        return null;
    }
  };

  render() {
    const {
      autentizace,
      autentizace: { typAutentizace, datumZalozeni },
      logPrihlaseni,
      typExternichDat,
    } = this.props;
    let typCaption;

    if (datumZalozeni) {
      switch (typAutentizace) {
        case TypAutentizace.JMENO_HESLO:
          typCaption = i18n(this.props.lang, TypAutentizaceInfo.getCaption(typAutentizace), autentizace.login);
          break;

        default:
          typCaption = i18n(this.props.lang, TypAutentizaceInfo.getCaption(typAutentizace));
          break;
      }
    } else {
      typCaption = i18n(this.props.lang, TypAutentizaceInfo.getNepripojenoCaption(typAutentizace));
    }

    return (
      <Row className="mb-2">
        <Col xs={12} sm={8}>
          <Row>
            <DataBlock xs={12} sm={6} label={i18n(this.props.lang, "ProfilePage_loginType")}>
              {typCaption}
            </DataBlock>
            <DataBlock xs={12} sm={3} label={i18n(this.props.lang, "ProfilePage_loginRegistered")}>
              {datumZalozeni && formatDate(datumZalozeni)}
            </DataBlock>
            <DataBlock xs={12} sm={3} label={i18n(this.props.lang, "ProfilePage_loginLastLogin")}>
              {logPrihlaseni && formatDate(logPrihlaseni.datumPrihlaseni)}
            </DataBlock>
          </Row>
        </Col>
        <Col className={"text-left text-sm-right"} xs={12} sm={4}>
          {datumZalozeni && this.renderAutentizaceAction(typAutentizace, autentizace, typExternichDat)}
        </Col>
      </Row>
    );
  }
}

const AutentizaceInfo = withLang(connect()(AutentizaceInfoComponent));

const PristupneSubjektyPanel = ({
  userId,
  subjektyRows,
  children,
  lang,
}: React.PropsWithChildren<{ userId: number; subjektyRows: any[] }>) => {
  return (
    <Card className="border-0 mb-4">
      <CardHeader className={"pb-0"}>
        <Row>
          <Col md={12}>
            <h2>{i18n(lang, "ProfilePage_pristupyLabel")}</h2>
          </Col>
        </Row>
      </CardHeader>
      <CardBody className="pt-2 pb-0">
        {subjektyRows.map((data, key) => (
          <SubjektBlock userId={userId} subjektData={data} key={key} lang={lang}/>
        ))}
        {children}
      </CardBody>
    </Card>
  );
};

const SubjektBlock = ({ userId, subjektData, lang }) => {
  return (
    <Row className="pb-2">
      <Col>
        <Row key="sub-1">
          <Col className={"pb-3"} xs={12} sm={4} md={8}>
            <strong>
              {subjektData.subjektNazev}
              <br />
            </strong>
            {(subjektData.subjektAdresa && subjektFormatter.getAdresa(subjektData.subjektAdresa)) || "-"}
          </Col>
          <DataBlock label={i18n(lang, "ProfilePage_pristupyTypVazby")} md={4}>
            {subjektData.typVazby && i18n(lang, `TypVazbyInfo_${subjektData.typVazby}`)}
          </DataBlock>
        </Row>
        <Row key="sub-2">
          <DataBlock label={i18n(lang, "ProfilePage_pristupyDokumenty")} md={8}>
            {subjektData.dokumenty &&
              subjektData.dokumenty.map((dokument, i) => (
                <DocumentBlock userId={userId} dokument={dokument} key={`subjDokumentDetail-${i}`} />
              ))}
          </DataBlock>
          <DataBlock label={i18n(lang, "ProfilePage_pristupyDalsi")} md={4}>
            {subjektData.dalsiPristupy}
          </DataBlock>
        </Row>
      </Col>
    </Row>
  );
};

class AktivaceUctuComponent extends React.Component<any> {
  handleSubmit = (kodAktivace) => {
    const { userProfileDetail } = this.props;
    const userId = userProfileDetail.data.userId;
    return SpravaUctuApi.aktivovatUcet(userId, {kodAktivace: kodAktivace.code});
  };
  handleSubmitSuccess = () => {
    const { onActivate } = this.props;
    toastr.success(i18n(this.props.lang, "ProfilePage_ucetAktivovan"));
    onActivate();
  };

  render() {
    return (
      <div>
        <Card className="border-0 mb-4">
          <CardHeader className={"pb-0"}>
            <Row>
              <Col>
                <h4>{i18n(this.props.lang, "ProfilePage_ucetAktivace")}</h4>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <AktivaceUctuForm onSubmit={this.handleSubmit} onSubmitSuccess={this.handleSubmitSuccess} />
          </CardBody>
        </Card>
      </div>
    );
  }
}

const AktivaceUctu = withLang(connect()(AktivaceUctuComponent));

const ProfilUzivatele = ({ typExternichDat, onExternalDetailChange, stavUctu, onActivate, onPortalRedirect, props }) => {
  const {
    userProfileDetail,
    userProfileLoginList,
    userProfileExternalDetail,
    userProfileSubjektExternalList,
    userProfileSubjektList,
  } = props;
  let showNoExtendedDataAlert = !userProfileExternalDetail.data;
  let subjektyRows = !userProfileSubjektExternalList.fetched
    ? userProfileSubjektList.rows
    : userProfileSubjektExternalList.rows;
  return (
    <div>
      {stavUctu === StavUctu.CEKA_NA_AKTIVACI && (
        <AktivaceUctu userProfileDetail={userProfileDetail} onActivate={onActivate} />
      )}
      {typExternichDat === TypExternichDat.NEDOSTUPNE && (
        <Alert color="warning" className="p-2 pl-4">
            {i18n(props.lang, "ProfilePage_dataInaccessible")}
        </Alert>
      )}
      <ZakladniUdajePanel
        typExternichDat={typExternichDat}
        detail={userProfileDetail}
        externalDetail={userProfileExternalDetail}
        onChange={onExternalDetailChange}
      />
      <ZpusobyPrihlaseniPanel
        onPortalRedirect={onPortalRedirect}
        typExternichDat={typExternichDat}
        userProfileLoginList={userProfileLoginList}
        posledniUspesnaPrihlaseni={
          userProfileExternalDetail.data ? userProfileExternalDetail.data.posledniUspesnaPrihlaseni : []
        }
        lang={props.lang}
      />
      {stavUctu === StavUctu.AKTIVOVANY && !userProfileDetail.data.popRezim && (
        <PristupneSubjektyPanel userId={userProfileDetail.data.userId} subjektyRows={subjektyRows} lang={props.lang} />
      )}
    </div>
  );
};

class ProfilePage extends React.Component<any> {
  constructor(props) {
    super(props);

    this.state = {
      fetchUserProfileExternalCount: 0,
    };
  }

  componentDidMount() {
    this.fetchData(this.props);
    this.fetchUserProfileExternal(this.props);
    this.fetchSubjektListExternal(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchUserProfileExternal(props) {
    const key = props.authInfo.data.login;
    console.log("fetching external profile data");
    UserProfileApi.getUserProfileExternal(key).then((data) => {
      this.setState({
        fetchUserProfileExternalCount: this.state.fetchUserProfileExternalCount + 1,
      });
      if (!data) {
        window.setTimeout(() => this.fetchUserProfileExternal(props), 30000);
      } else {
        props.dispatch(ProfileActions.setUserProfileExternalDetail(key, data));
      }
    });
  }

  fetchSubjektListExternal(props) {
    const key = props.authInfo.data.login;
    console.log("fetching external subjekt list data");
    UserProfileApi.getSubjektListExternal(key).then((data) => {
      if (!data) {
        window.setTimeout(() => this.fetchSubjektListExternal(props), 30000);
      } else {
        props.dispatch(ProfileActions.setSubjektListExternal(key, data));
      }
    });
  }

  fetchData = (props) => {
    if (!props.authInfo.fetched) {
      return;
    }

    const key = props.authInfo.data.login;
    props.dispatch(ProfileActions.fetchUserProfileDetailIfNeeded(key));
    props.dispatch(ProfileActions.fetchLoginListIfNeeded(key));
    props.dispatch(ProfileActions.fetchSubjektListIfNeeded(key));
  };
  handleExternalDetailChange = () => {
    this.props.dispatch(ProfileActions.invalidateUserProfileDetail());
    this.fetchUserProfileExternal(this.props);
  };

  /**
   * Odeslani zpravy nadrazenemu oknu o uspesne aktivaci.
   */
  sendAccountActivationMessage = () => {
    const parentWindow = window.parent;

    if (parentWindow) {
      parentWindow.postMessage(
        {
          type: "account-activation",
          result: "OK",
        },
        "*"
      );
    }
  };

  /**
   * Po aktivaci účtu - refresh dat.
   */
  handleActivate = () => {
    this.props.dispatch(ProfileActions.invalidateUserProfileDetail());
    this.fetchUserProfileExternal(this.props);
    this.fetchSubjektListExternal(this.props);
    this.sendAccountActivationMessage();
  };

  render() {
    const { userProfileExternalDetail, userProfileDetail, userProfileLoginList, userProfileSubjektList } = this.props;
    const { fetchUserProfileExternalCount } = this.state;

    if (!(userProfileDetail.data && userProfileLoginList.rows && userProfileSubjektList.rows)) {
      return <Loader />;
    }

    const stavUctu = userProfileDetail.data.stavUctu;
    let profilStavDesc;

    if (stavUctu === StavUctu.REGISTROVANY || stavUctu === StavUctu.CEKA_NA_AKTIVACI) {
      profilStavDesc = <small>{i18n(this.props.lang, "ProfilePage_stavNotActivated")}</small>;
    }

    const typExternichDat: TypExternichDat =
      fetchUserProfileExternalCount === 0
        ? TypExternichDat.CEKA
        : userProfileExternalDetail.data
        ? TypExternichDat.NACTENO
        : TypExternichDat.NEDOSTUPNE;

    return (
      <div className={"overflow-hidden profile-page " + (window as any).brandConfig.theme}>
        <Container fluid className={"px-0"}>
          <Row className="page-heading">
            <Col>
              <h1 className="mb-0">{i18n(this.props.lang, "ProfilePage_mujProfil")}</h1>
              {profilStavDesc}
            </Col>
          </Row>

          <ProfilUzivatele
            onPortalRedirect={() => {
                sendAccountDeleteMessage();
            }}
            typExternichDat={typExternichDat}
            props={this.props}
            stavUctu={stavUctu}
            onExternalDetailChange={this.handleExternalDetailChange}
            onActivate={this.handleActivate}
          />
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
    userProfileDetail: utils.storeFromArea(state, ProfileActions.USER_PROFILE_DETAIL_AREA),
    userProfileExternalDetail: utils.storeFromArea(state, ProfileActions.USER_PROFILE_EXTERNAL_DETAIL_AREA),
    userProfileLoginList: utils.storeFromArea(state, ProfileActions.USER_PROFILE_LOGIN_LIST_AREA),
    userProfileSubjektList: utils.storeFromArea(state, ProfileActions.USER_PROFILE_SUBJEKT_DETAIL_AREA),
    userProfileSubjektExternalList: utils.storeFromArea(state, ProfileActions.USER_PROFILE_SUBJEKT_EXTERNAL_LIST_AREA),
  };
}

export default withLang(connect(mapStateToProps)(ProfilePage));
